import { ForecastTypeBase } from './base/forecast-type-base';

export class ForecastType extends ForecastTypeBase { }